import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function AdminPage() {
  const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";
  const token = localStorage.getItem("token");

  // 공지사항 상태
  const [announcement, setAnnouncement] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [expiresAt, setExpiresAt] = useState("");
  const [saveMsg, setSaveMsg] = useState("");
  const [announcementId, setAnnouncementId] = useState(null);

  // 공지사항 불러오기
  useEffect(() => {
    fetch(`${API_BASE_URL}/admin/announcement/latest`)
      .then(res => res.json())
      .then(data => {
        if (data) {
          setAnnouncement(data.message || "");
          if (data.created_at) {
            setCreatedAt(data.created_at.replace(" ", "T").slice(0, 16)); // datetime-local 포맷
          }
          if (data.expires_at) {
            setExpiresAt(data.expires_at.replace(" ", "T").slice(0, 16));
          }
        }
      })
      .catch(err => console.error("공지 불러오기 오류:", err));
  }, [API_BASE_URL]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/admin/announcement/latest`)
      .then(res => res.json())
      .then(data => {
        if (data) {
          setAnnouncementId(data.id);
          setAnnouncement(data.message || "");
          if (data.created_at) {
            setCreatedAt(data.created_at.replace(" ", "T").slice(0, 16));
          }
          if (data.expires_at) {
            setExpiresAt(data.expires_at.replace(" ", "T").slice(0, 16));
          }
        }
      })
      .catch(err => console.error("공지 불러오기 오류:", err));
  }, [API_BASE_URL]);

  // 공지 저장
  const handleSaveAnnouncement = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/admin/announcement/update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          id: announcementId,
          message: announcement,
          created_at: createdAt || null,
          expires_at: expiresAt || null
        })
      });
      if (!res.ok) throw new Error("공지 저장 실패");
      await res.json();
      setSaveMsg("공지 저장 완료");
    } catch (err) {
      setSaveMsg("공지 저장 실패: " + err.message);
    }
  };

  // 문제 생성 상태
  const [quizType, setQuizType] = useState("상식");
  const [count, setCount] = useState(5);
  const [loading, setLoading] = useState(false);
  const [resultMsg, setResultMsg] = useState("");
  const [difficulty, setDifficulty] = useState("보통");
  const difficultyOptions = ["보통", "어려움"];

  const quizTypes = ["상식", "산수", "이야기 기억력", "사자성어"];

  const handleRagCreate = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/rag-create`);
      if (!res.ok) throw new Error("RAG 생성 실패");
      const data = await res.json();
      alert("RAG 생성 완료: " + JSON.stringify(data));
    } catch (err) {
      alert("오류 발생: " + err.message);
    }
  };

  const handleGenerateCrewAI = async () => {
    setLoading(true);
    setResultMsg("");
    try {
      const res = await fetch(
        `${API_BASE_URL}/brain-trainer/admin/generate-questions-crewai`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ quizType, count, difficulty }),
          credentials: "include"
        }
      );
      if (!res.ok) throw new Error("문제 생성 실패");
      const data = await res.json();
      setResultMsg(`CrewAI - 총 ${data.generated}문제 생성, ${data.saved}문제 저장 완료`);
    } catch (err) {
      setResultMsg("CrewAI 문제 생성 중 오류: " + err.message);
    } finally {
      setLoading(false);
    }
  };


  const handleGenerate = async () => {
    setLoading(true);
    setResultMsg("");
    try {
      const res = await fetch(
        `${API_BASE_URL}/brain-trainer/admin/generate-questions`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ quizType, count, difficulty  }),
          credentials: "include"
        }
      );
      if (!res.ok) throw new Error("문제 생성 실패");
      const data = await res.json();
      setResultMsg(`총 ${data.generated}문제 생성, ${data.saved}문제 저장 완료`);
    } catch (err) {
      setResultMsg("문제 생성 중 오류가 발생했습니다: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 text-white bg-gray-900 min-h-screen">
      <h1 className="text-2xl font-bold mb-6 text-center">관리자 페이지</h1>
      <div className="flex flex-col items-center gap-4 mb-6">
        <Link to="/" className="px-4 py-2 bg-blue-800 rounded hover:bg-blue-700">메인으로</Link>
        <Link to="/jw/feedbacks" className="px-4 py-2 bg-blue-500 rounded hover:bg-blue-400">피드백 관리</Link>
        <Link to="/admin/inquiries" className="px-4 py-2 bg-purple-500 rounded hover:bg-purple-400">문의 관리</Link>
        <Link to="/jw/pdfupload" className="px-4 py-2 bg-green-500 rounded hover:bg-green-400">PDF 업로드</Link>
        <button onClick={handleRagCreate} className="px-4 py-2 bg-yellow-500 rounded hover:bg-yellow-400">RagCreate 실행</button>
      </div>

      {/* 🔹 공지사항 수정 UI */}
      <div className="flex justify-center mt-8">
        <div className="bg-gray-800 p-4 rounded-lg w-full max-w-md">
          <h2 className="text-lg font-bold mb-4 text-center">📢 공지사항 수정</h2>

          <label className="block mb-1">내용</label>
          <textarea
            value={announcement}
            onChange={(e) => setAnnouncement(e.target.value)}
            className="p-2 rounded bg-gray-700 text-white w-full h-24 mb-3"
          />

          <label className="block mb-1">시작일 (created_at)</label>
          <input
            type="datetime-local"
            value={createdAt}
            onChange={(e) => setCreatedAt(e.target.value)}
            className="p-2 rounded bg-gray-700 text-white w-full mb-3"
          />

          <label className="block mb-1">종료일 (expires_at)</label>
          <input
            type="datetime-local"
            value={expiresAt}
            onChange={(e) => setExpiresAt(e.target.value)}
            className="p-2 rounded bg-gray-700 text-white w-full mb-3"
          />

          <button
            onClick={handleSaveAnnouncement}
            className="mt-2 px-4 py-2 bg-green-500 rounded hover:bg-green-600 w-full"
          >
            공지 저장
          </button>
          {saveMsg && <p className="mt-2 text-center text-green-400">{saveMsg}</p>}
        </div>
      </div>

      {/* 기존 문제 생성 UI */}
      <div className="flex justify-center mt-8">
        <div className="bg-gray-800 p-4 rounded-lg w-full max-w-md">
          <h2 className="text-lg font-bold mb-4 text-center">🛠 관리자 문제 생성</h2>
          <div className="mb-4">
            <label className="block mb-1">퀴즈 유형</label>
            <select
              value={quizType}
              onChange={(e) => setQuizType(e.target.value)}
              className="p-2 rounded bg-gray-700 text-white w-full"
            >
              {quizTypes.map((t) => (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label className="block mb-1">난이도</label>
            <select
              value={difficulty}
              onChange={(e) => setDifficulty(e.target.value)}
              className="p-2 rounded bg-gray-700 text-white w-full"
            >
              {difficultyOptions.map((d) => (
                <option key={d} value={d}>{d}</option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label className="block mb-1">문제 개수</label>
            <input
              type="number"
              min="1"
              max="10"
              value={count}
              onChange={(e) => setCount(Number(e.target.value))}
              className="p-2 rounded bg-gray-700 text-white w-full"
            />
          </div>
          <button
            onClick={handleGenerate}
            disabled={loading}
            className="px-4 py-2 bg-blue-500 rounded hover:bg-blue-600 w-full"
          >
            {loading ? "문제 생성 중..." : "문제 생성하기"}
          </button>
          <br/>
          <br/>
          <button
            onClick={handleGenerateCrewAI}
            disabled={loading}
            className="px-4 py-2 bg-purple-500 rounded hover:bg-purple-600 w-full"
          >
            {loading ? "CrewAI 생성 중..." : "CrewAI 문제 생성"}
          </button>
          {resultMsg && <p className="mt-4 text-green-400 text-center">{resultMsg}</p>}
        </div>
      </div>
    </div>
  );
}
